import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../routes/feature";
import { RouteLayout } from "../../../../routes/layout";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportLeadsCreatedWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);
  const history = useHistory();

  return (
    <ReportWidgetCard
      title="New Leads"
      value={data.leads?.created?.total.toString() || "0"}
      isLoading={data.isLoading}
      explanation="Sum of all leads created within the selected period. Does not include leads that re-submit."
      variation={data.leads?.created?.variation}
      onClick={() => {
        history.push({
          pathname: createClubLink(RouteLayout.Staff, RouteFeature.NewLeads),
          search: QueryString.stringify({
            dates: { startDate: data.startDate, endDate: data.endDate },
            backRoute: parentRoute,
          }),
        });
      }}
    />
  );
};
